/*Generated from the `:::slide{key="7ed1b468-3283-4b72-83c0-8c277c0bf4a3" slug="falling-tone"}` (simplified/001-P1/001/岸.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      keepWithNext: "true",
      count: "3",
      children: _jsxs(html.p, {
        children: ["The ", _jsx(html.strong, {
          children: "falling tone",
          components: html
        }), " roughly corresponds to the intonation of an English exclamation:"]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "3",
      children: _jsxs(html.p, {
        children: ["àn ≈ \"an!\" (as in ", _jsx(html.strong, {
          children: "an",
          components: html
        }), "nouncer)"]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "3",
      children: _jsx(html.p, {
        children: "Next, a character whose falling-tone Pinyin is an initial-final pair.",
        components: html
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
